import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setClaimMoreInfoNeeded = (claimId, message) =>
  call(websocketFetch, 'set_claim_more_information_needed', {
    claim_id: claimId,
    message,
  });
